import { ChannelCardTestID } from "@/constants/TestID";
import { AvatarStyleMapper } from "@/ui/core/Avatar";
import AvatarCard from "@/ui/core/AvatarCard";
import { Box, FlatList } from "@/ui/layout";
import { ListDimensions } from "@/ui/layout/list/ListComponents";
import { ColorToken } from "@/ui/theme/tokens";
import { toSentenceCase } from "@/utils/string.util";

const MentionItemHeight =
  AvatarStyleMapper.xs.size + ListDimensions.HorizontalSeparatorWidth;
const MentionListMaxHeight = 200;

interface MentionListProps extends ViewWithTestID {
  onSelect: (user: BaseUserAvatarProps) => void;
  users?: BaseUserAvatarProps[];
}

const getSubtitle = (userType?: string) => toSentenceCase(userType ?? "Member");

const MentionList = ({ onSelect, users: initialUsers }: MentionListProps) => {
  const users = initialUsers ?? [];
  const renderItem = ({ item }: { item: BaseUserAvatarProps }) => {
    const { imageUrl, userId, userName, userType } = item;
    const subtitle = getSubtitle(userType);

    return (
      <Box onPress={() => onSelect(item)}>
        <AvatarCard
          imageUrl={imageUrl}
          isHorizontal
          subtitle={subtitle}
          userId={userId}
          userName={userName}
          userType={userType}
        />
      </Box>
    );
  };

  const height = Math.min(
    users.length * MentionItemHeight,
    MentionListMaxHeight,
  );

  return (
    <Box
      borderColor={ColorToken.NeutralLine}
      borderWidth={1}
      height={height}
      padding={8}
    >
      <FlatList
        data={users}
        keyboardShouldPersistTaps="handled"
        keyExtractor={(item) => item.userId}
        renderItem={renderItem}
        separatorType="line"
        shouldRemoveContentVerticalPadding
        shouldRemoveStyleHorizontalPadding
        testID={ChannelCardTestID.MentionList}
      />
    </Box>
  );
};

export default MentionList;
